import Box from '@mui/material/Box';

interface TimeIndicatorProps {
  visible: boolean;
  position: number; // Pixels
  time: number; // Unix timestamp
}

const TimeIndicator = ({ visible, position }: TimeIndicatorProps) => {
  if (!visible) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        height: '100%',
        bottom: 0,
        zIndex: 3,
        transform: 'translateX(-50%)',
        left: position,
      }}
    >
      <Box
        sx={{
          height: '100%',
          width: 2,
          backgroundColor: 'text.primary',
        }}
      />
    </Box>
  );
};

export default TimeIndicator;
